import { render, staticRenderFns } from "./AskapriceStylesComponent.vue?vue&type=template&id=43f8037a"
import script from "./AskapriceStylesComponent.vue?vue&type=script&lang=ts"
export * from "./AskapriceStylesComponent.vue?vue&type=script&lang=ts"
import style0 from "./AskapriceStylesComponent.vue?vue&type=style&index=0&id=43f8037a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports